import { appConfig } from '../app-config.js';

/**
 * @param {object} [config]
 * @returns {boolean} true when the frontend must use live HTTP clients.
 */
export function shouldForceLive(config = appConfig) {
  return config?.forceLive === true;
}

/**
 * @param {object} [config]
 * @returns {boolean} true when the researcher launcher may be reached.
 */
export function shouldAllowResearcher(config = appConfig) {
  return config?.allowResearcher === true;
}

/**
 * @param {string} [search]
 * @returns {string} query string without a leading question mark.
 */
export function normalizeSearch(search = '') {
  return search.startsWith('?') ? search.slice(1) : search;
}

/**
 * @param {string} [search]
 * @param {object} [config]
 * @returns {'mock' | 'http'} selected frontend client mode.
 */
export function resolveClientMode(search = '', config = appConfig) {
  if (shouldForceLive(config)) return 'http';
  try {
    const params = new URLSearchParams(normalizeSearch(search));
    return params.get('mock') === '0' ? 'http' : 'mock';
  } catch (error) {
    console.warn('[runtime] client-mode search parse failed; using mock', error);
    return 'mock';
  }
}
